<template>
    <div class="tooltip" @click.stop="$emit('click')">
        <slot />
        <span class="tooltiptext">{{ text }}</span>
    </div>
</template>

<script>
export default {
    name: "Tooltip",
    data() {
        return {};
    },
    components: {},
    props: {
        text: String
    }
};
</script>

<style lang="scss">
.tooltip {
    position: relative;
    cursor: pointer;
}
.tooltip .tooltiptext {
    padding: 0 8px;
    width: 175px;
    height: 34px;
    background-color: black;
    display: none;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 6px;
    position: absolute;
    z-index: 1;
    top: -38px;
    left: calc(35% - 79px);
    font-family: "Roboto", sans-serif;
    font-size: 12px;
    line-height: 18px;
    color: #ffffff;
}
.tooltip .tooltiptext::after {
    content: "";
    position: absolute;
    top: calc(100% + 3px);
    right: 50%;
    margin-top: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent black transparent transparent;
    transform: rotate(-90deg);
}
.tooltip:hover .tooltiptext {
    display: flex;
}
</style>
